import { centsToPrice } from '@/utils/formatter';
import i18n from '@/utils/i18n';
import {
  MerchantOrderItemOption,
  MerchantOrderItemStatus,
  Revision,
} from './HandleStatusChange';
import { Currency } from '@/utils/price';
import { ContentSection } from '../Layout/ContentSection';

/**
 * Only to be used in EditMerchantOrder
 */
export const PurchasePrice = function purchasePrice(props: {
  revision: Revision;
  orderItemOptions: MerchantOrderItemOption[];
}) {
  const { revision, orderItemOptions } = props;
  function calcPurchasePrice() {
    let priceInCents = 0;
    const deliveryItems = revision.items.filter(
      (i) =>
        i.status === MerchantOrderItemStatus.Delivery &&
        parseInt(i.amount as string) > 0,
    );
    for (const item of deliveryItems) {
      const option = orderItemOptions.find((opt) => opt.typeId === item.typeId);
      if (option != null) {
        priceInCents +=
          parseInt(item.amount as string) * option.purchasePriceCents;
      }
    }
    return priceInCents;
  }

  return (
    <ContentSection title={i18n.t('MerchantOrder:purchasePrice')} locked>
      <div className="input-group mb-3">
        <span className="input-group-text" id="basic-addon1">
          {i18n.t('MerchantOrder:purchasePrice')}
        </span>
        <input
          type="text"
          className="form-control"
          disabled
          value={centsToPrice(calcPurchasePrice(), Currency.EUR)}
        />
      </div>
    </ContentSection>
  );
};
